export default __webpack_public_path__ + "static/media/Legion-Logo-White-Horizontal-2048x562.210bee53.webp";